const API_ENDPOINT = 'https://signaibackend.epiccraftings.com/api/generate/single';
const API_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImE1MDcxNzk5LTEyOWItNDJhNy1hYzlmLTZkMzVkYzcyMDQ2MCIsInVzZXJuYW1lIjoic2hhaHphZHlzdHNvbCIsImVtYWlsIjoic2hhaHphZEB5c3Rzb2wuY29tIiwidG9rZW5WZXJzaW9uIjoxLCJpYXQiOjE3NTkzODE4Mjl9.iBIG54Tv6-fw0Knxl1iziY2DcRTKrfCVE1OBJsthO6M';
const MAX_FILE_SIZE = 10 * 1024 * 1024;
const MAX_CHARACTER_LIMIT = 25;

const elements = {
  form: document.getElementById('signForm'),
  logoFile: document.getElementById('logoFile'),
  sceneFile: document.getElementById('sceneFile'),
  logoUploadArea: document.getElementById('logoUploadArea'),
  sceneUploadArea: document.getElementById('sceneUploadArea'),
  logoPreview: document.getElementById('logoPreview'),
  scenePreview: document.getElementById('scenePreview'),
  previewImage: document.getElementById('previewImage'),
  previewArea: document.getElementById('previewArea'),
  zoomOverlay: document.getElementById('zoomOverlay'),
  magnifierView: document.getElementById('magnifierView'),
  magnifierContent: document.querySelector('.magnifier-content'),
  loadingSpinner: document.getElementById('loadingSpinner'),
  loadingMessage: document.getElementById('loadingMessage'),
  placeholderContent: document.querySelector('.placeholder-content'),
  errorPanel: document.getElementById('errorPanel'),
  errorMessage: document.getElementById('errorMessage'),
  closeErrorBtn: document.getElementById('closeErrorBtn'),
  resetBtn: document.getElementById('resetBtn'),
  generateBtn: document.getElementById('generateBtn'),
  toast: document.getElementById('toast'),
  backboardColorPicker: document.getElementById('backboardColorPicker'),
  backboardColor: document.getElementById('backboardColor'),
  racewayColorPicker: document.getElementById('racewayColorPicker'),
  racewayColor: document.getElementById('racewayColor'),
  advancedDrawer: document.getElementById('advancedDrawer'),
  advancedSettingsBtn: document.getElementById('advancedSettingsBtn'),
  closeDrawerBtn: document.getElementById('closeDrawerBtn'),
  saveDrawerBtn: document.getElementById('saveDrawerBtn')
};

const loadingMessages = [
  "Sit tight! We're crafting your preview...",
  "Almost there! Polishing the details...",
  "Creating magic, just a moment...",
  "Perfecting your design...",
  "Bringing your vision to life..."
];

let messageInterval = null;

function setupFileUpload(inputElement, previewElement, uploadArea) {
  const placeholder = uploadArea.querySelector('.upload-placeholder');

  function removeFile() {
    inputElement.value = '';
    previewElement.classList.add('hidden');
    placeholder.classList.remove('hidden');
  }

  inputElement.addEventListener('change', (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > MAX_FILE_SIZE) {
      showToast('File exceeds maximum size of 10 MB.', 'error');
      inputElement.value = '';
      return;
    }

    placeholder.classList.add('hidden');
    previewElement.classList.remove('hidden');

    const reader = new FileReader();
    reader.onload = (event) => {
      const fileName = file.name;
      const fileType = file.type;
      const fileNameShort = getFileName(fileName);
      if (fileType === 'image/svg+xml') {
        previewElement.innerHTML = `
          <img src="${event.target.result}" alt="${fileName}">
          <span>${fileNameShort}</span>
          <button type="button" class="file-preview-remove" aria-label="Remove file">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        `;
      } else {
        previewElement.innerHTML = `
          <img src="${event.target.result}" alt="${fileName}">
          <span>${fileNameShort}</span>
          <button type="button" class="file-preview-remove" aria-label="Remove file">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        `;
      }

      const removeBtn = previewElement.querySelector('.file-preview-remove');
      if (removeBtn) {
        removeBtn.addEventListener('click', removeFile);
      }
    };
    reader.readAsDataURL(file);
  });

  uploadArea.addEventListener('dragover', (e) => {
    e.preventDefault();
    uploadArea.style.borderColor = 'var(--primary-color)';
  });

  uploadArea.addEventListener('dragleave', () => {
    uploadArea.style.borderColor = 'var(--border-color)';
  });

  uploadArea.addEventListener('drop', (e) => {
    e.preventDefault();
    uploadArea.style.borderColor = 'var(--border-color)';

    const file = e.dataTransfer.files[0];
    if (file) {
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      inputElement.files = dataTransfer.files;
      inputElement.dispatchEvent(new Event('change'));
    }
  });
}
function getFileName(fileName){
  const maxLength = MAX_CHARACTER_LIMIT;
  let displayName = fileName;

  if (fileName.length > maxLength) {
    const ext = fileName.split('.').pop(); // get extension
    const base = fileName.substring(0, maxLength - (ext.length + 4)); 
    displayName = base + "... ." + ext; // e.g. "longfilenameexample... .pdf"
  }
  return displayName;
}
function syncColorInputs(pickerElement, textElement) {
  pickerElement.addEventListener('input', (e) => {
    textElement.value = e.target.value;
  });

  textElement.addEventListener('input', (e) => {
    const value = e.target.value;
    if (value.startsWith('#')) {
      pickerElement.value = value;
    }
  });
}

function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

// function getClientIP() {
//   return fetch('https://api.ipify.org?format=json')
//     .then(res => res.json())
//     .then(data => data.ip)
//     .catch(() => '0.0.0.0');
// }

function showToast(message, type = 'success') {
  elements.toast.textContent = message;
  elements.toast.className = `toast ${type}`;
  elements.toast.classList.remove('hidden');

  setTimeout(() => {
    elements.toast.classList.add('hidden');
  }, 4000);
}

function showError(message) {
  elements.errorMessage.textContent = message;
  elements.errorPanel.classList.remove('hidden');
}

function hideError() {
  elements.errorPanel.classList.add('hidden');
}

function showButtonLoading(button) {
  const btnText = button.querySelector('.btn-text');
  if (btnText) {
    btnText.innerHTML += '<span class="btn-spinner"></span>';
  }
  button.disabled = true;
}

function hideButtonLoading(button) {
  const btnText = button.querySelector('.btn-text');
  const spinner = button.querySelector('.btn-spinner');
  if (spinner) {
    spinner.remove();
  }
  button.disabled = false;
}

function showLoading() {
  elements.placeholderContent.classList.add('hidden');
  elements.previewImage.classList.add('hidden');
  elements.loadingSpinner.classList.remove('hidden');
  showButtonLoading(elements.generateBtn);

  // Add generating class for progress animation
  const previewArea = document.getElementById('previewArea');
  previewArea.classList.add('generating');

  let messageIndex = 0;
  elements.loadingMessage.textContent = loadingMessages[messageIndex];

  messageInterval = setInterval(() => {
    messageIndex = (messageIndex + 1) % loadingMessages.length;
    elements.loadingMessage.textContent = loadingMessages[messageIndex];
  }, 3000);
}

function hideLoading() {
  elements.loadingSpinner.classList.add('hidden');
  hideButtonLoading(elements.generateBtn);

  // Remove generating class
  const previewArea = document.getElementById('previewArea');
  previewArea.classList.remove('generating');

  if (messageInterval) {
    clearInterval(messageInterval);
    messageInterval = null;
  }
}

function showPreview(imageUrl) {
  elements.placeholderContent.classList.add('hidden');
  elements.loadingSpinner.classList.add('hidden');
  elements.previewImage.src = imageUrl;
  elements.previewImage.classList.remove('hidden');
  hideButtonLoading(elements.generateBtn);

  // Remove generating class
  const previewArea = document.getElementById('previewArea');
  previewArea.classList.remove('generating');

  if (messageInterval) {
    clearInterval(messageInterval);
    messageInterval = null;
  }
}

async function resetForm() {
  showButtonLoading(elements.resetBtn);

  await new Promise(resolve => setTimeout(resolve, 300));

  elements.form.reset();
  elements.logoPreview.classList.add('hidden');
  elements.scenePreview.classList.add('hidden');
  elements.logoUploadArea.querySelector('.upload-placeholder').classList.remove('hidden');
  elements.sceneUploadArea.querySelector('.upload-placeholder').classList.remove('hidden');
  elements.previewImage.classList.add('hidden');
  elements.placeholderContent.classList.remove('hidden');
  hideError();
  elements.backboardColorPicker.value = '#000000';
  elements.backboardColor.value = '#000000';
  elements.racewayColorPicker.value = '#C0C0C0';
  elements.racewayColor.value = 'Silver';

  hideButtonLoading(elements.resetBtn);
}

async function handleFormSubmit(e) {
  e.preventDefault();

  const logoFile = elements.logoFile.files[0];
  const email = document.getElementById('email').value;

  if (!logoFile) {
    showToast('Please upload your logo (PNG, JPG, or SVG).', 'error');
    return;
  }

  if (!validateEmail(email)) {
    showToast('Please enter a valid email address.', 'error');
    return;
  }

  const backboardDepth = parseInt(document.getElementById('backboardDepth').value);
  const backboardPadding = parseInt(document.getElementById('backboardPadding').value);
  const studStandoff = parseInt(document.getElementById('studStandoff').value);

  if (backboardDepth < 0 || backboardPadding < 0 || studStandoff < 0) {
    showToast('Numeric values must be positive.', 'error');
    return;
  }
  showPreviewArea();
  showLoading();
  hideError();

  try {
    const ipAddress = (localStorage.getItem("location").match(/\b\d{1,3}(\.\d{1,3}){3}\b/)||[])[0];
    const formData = new FormData();

    formData.append('logo_file', logoFile);

    const sceneFile = elements.sceneFile.files[0];
    if (sceneFile) {
      formData.append('scene_file', sceneFile);
    }

    formData.append('email', email);
    formData.append('ipAddress', ipAddress);
    formData.append('signType', document.getElementById('signType').value);
    formData.append('mountingType', document.getElementById('mountingType').value);
    formData.append('isLightingOn', document.getElementById('isLightingOn').checked);
    formData.append('backboardDepth', backboardDepth);
    formData.append('backboardColor', document.getElementById('backboardColor').value);
    formData.append('backboardMaterial', document.getElementById('backboardMaterial').value);
    formData.append('backboardLit', document.getElementById('backboardLit').checked);
    formData.append('backboardPadding', backboardPadding);
    formData.append('studStandoff', studStandoff);
    formData.append('racewayFinish', document.getElementById('racewayFinish').value);
    formData.append('racewayColor', document.getElementById('racewayColor').value);
    formData.append('backerBorderStyle', document.getElementById('backerBorderStyle').value);
    formData.append('faceLitTrimStyle', document.getElementById('faceLitTrimStyle').value);

    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${API_TOKEN}`
      },
      body: formData
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error:', errorText);
      throw new Error(`Generation failed with status ${response.status}`);
    }

    const contentType = response.headers.get('content-type');

    if (contentType && contentType.includes('application/json')) {
      const result = await response.json();

      if (result.status === 'queued' || result.jobId) {
        hideLoading();
        showToast('Generation queued — we\'ll email you when ready.', 'success');
      } else if (result.preview_url) {
        showPreview(result.preview_url);
        showToast('Preview generated.', 'success');
      } else {
        throw new Error('Unexpected response format');
      }
    } else {
      const blob = await response.blob();
      const imageUrl = URL.createObjectURL(blob);
      showPreview(imageUrl);
      showToast('Preview generated — check your email for download links.', 'success');
    }
  } catch (error) {
    console.error('Generation error:', error);
    hideLoading();
    showError('Generation failed. Please check your inputs and try again.');
  }
}
function showPreviewArea(){
  if (window.innerWidth <= 768) {
    const previewEl = document.getElementById("app");
    if (previewEl) {
      previewEl.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }
}
function setupPreviewDragDrop() {
  const previewSection = document.querySelector('.preview-section');

  previewSection.addEventListener('dragover', (e) => {
    e.preventDefault();
    e.stopPropagation();
    previewSection.style.background = 'linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 100%)';
    previewSection.style.borderColor = 'var(--primary-color)';
  });

  previewSection.addEventListener('dragleave', (e) => {
    e.preventDefault();
    e.stopPropagation();
    previewSection.style.background = 'var(--surface-light)';
  });

  previewSection.addEventListener('drop', (e) => {
    e.preventDefault();
    e.stopPropagation();
    previewSection.style.background = 'var(--surface-light)';

    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      elements.logoFile.files = dataTransfer.files;
      elements.logoFile.dispatchEvent(new Event('change'));
      showToast('Logo uploaded successfully!', 'success');
    } else if (file) {
      showToast('Please drop an image file (PNG, JPG, or SVG).', 'error');
    }
  });
}

function openAdvancedDrawer() {
  elements.advancedDrawer.classList.remove('hidden');
  document.body.style.overflow = 'hidden';
}

function closeAdvancedDrawer() {
  elements.advancedDrawer.classList.add('hidden');
  document.body.style.overflow = '';
}

function setupImageMagnifier() {
  const img = elements.previewImage;
  const overlay = elements.zoomOverlay;
  const magnifierView = elements.magnifierView;
  const magnifierContent = elements.magnifierContent;
  const previewArea = elements.previewArea;

  const zoomLevel = 2.5;
  const overlaySize = 150;

  function showZoom(e) {
    if (img.classList.contains('hidden')) {
      hideZoom();
      return;
    }

    const imgRect = img.getBoundingClientRect();
    const previewRect = previewArea.getBoundingClientRect();

    const x = e.clientX;
    const y = e.clientY;

    if (x < imgRect.left || x > imgRect.right || y < imgRect.top || y > imgRect.bottom) {
      hideZoom();
      return;
    }

    magnifierView.classList.remove('hidden');
    overlay.classList.remove('hidden');

    const relativeX = x - imgRect.left;
    const relativeY = y - imgRect.top;

    const percentX = (relativeX / imgRect.width) * 100;
    const percentY = (relativeY / imgRect.height) * 100;

    let overlayX = relativeX - overlaySize / 2;
    let overlayY = relativeY - overlaySize / 2;

    overlayX = Math.max(0, Math.min(overlayX, imgRect.width - overlaySize));
    overlayY = Math.max(0, Math.min(overlayY, imgRect.height - overlaySize));

    const overlayLeft = imgRect.left - previewRect.left + overlayX;
    const overlayTop = imgRect.top - previewRect.top + overlayY;

    overlay.style.left = overlayLeft + 'px';
    overlay.style.top = overlayTop + 'px';
    overlay.style.width = overlaySize + 'px';
    overlay.style.height = overlaySize + 'px';

    const magnifierRect = magnifierView.getBoundingClientRect();
    const zoomedWidth = imgRect.width * zoomLevel;
    const zoomedHeight = imgRect.height * zoomLevel;

    const bgPosX = -(percentX / 100) * zoomedWidth + magnifierRect.width / 2;
    const bgPosY = -(percentY / 100) * zoomedHeight + magnifierRect.height / 2;

    magnifierContent.style.backgroundImage = `url('${img.src}')`;
    magnifierContent.style.backgroundSize = `${zoomedWidth}px ${zoomedHeight}px`;
    magnifierContent.style.backgroundPosition = `${bgPosX}px ${bgPosY}px`;
  }

  function hideZoom() {
    magnifierView.classList.add('hidden');
    overlay.classList.add('hidden');
  }

  previewArea.addEventListener('mousemove', showZoom);
  previewArea.addEventListener('mouseleave', hideZoom);
}

function init() {
  setupFileUpload(elements.logoFile, elements.logoPreview, elements.logoUploadArea);
  setupFileUpload(elements.sceneFile, elements.scenePreview, elements.sceneUploadArea);
  setupPreviewDragDrop();
  setupImageMagnifier();

  syncColorInputs(elements.backboardColorPicker, elements.backboardColor);
  syncColorInputs(elements.racewayColorPicker, elements.racewayColor);

  elements.form.addEventListener('submit', handleFormSubmit);
  elements.resetBtn.addEventListener('click', resetForm);
  elements.closeErrorBtn.addEventListener('click', hideError);

  // Advanced drawer handlers
  elements.advancedSettingsBtn.addEventListener('click', openAdvancedDrawer);
  elements.closeDrawerBtn.addEventListener('click', closeAdvancedDrawer);
  elements.saveDrawerBtn.addEventListener('click', closeAdvancedDrawer);

  console.log('Sign Styler initialized');
  console.log('Connected to Sign AI API at:', API_ENDPOINT);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
